import api from './api'

// Tag types
export interface Tag {
  id: string
  name: string
  color: string
  tenantId: string
  createdAt: string
  updatedAt?: string
}

export interface CreateTagDto {
  name: string
  color: string
}

export interface UpdateTagDto {
  name?: string
  color?: string
}

// Predefined colors for tags
export const TAG_COLORS = [
  { name: 'Rojo', value: '#EF4444' },
  { name: 'Naranja', value: '#F97316' },
  { name: 'Amarillo', value: '#EAB308' },
  { name: 'Verde', value: '#22C55E' },
  { name: 'Azul', value: '#3B82F6' },
  { name: 'Morado', value: '#8B5CF6' },
  { name: 'Rosa', value: '#EC4899' },
  { name: 'Gris', value: '#6B7280' },
]

export const tagsApi = {
  // ==================== Tags CRUD ====================

  // Get all tags for tenant
  async getAll(): Promise<Tag[]> {
    const response = await api.get('/api/crm/tags')
    return response.data.data
  },

  // Get a specific tag
  async getById(id: string): Promise<Tag> {
    const response = await api.get(`/api/crm/tags/${id}`)
    return response.data.data
  },

  // Create a new tag
  async create(data: CreateTagDto): Promise<Tag> {
    const response = await api.post('/api/crm/tags', data)
    return response.data.data
  },

  // Update a tag
  async update(id: string, data: UpdateTagDto): Promise<Tag> {
    const response = await api.put(`/api/crm/tags/${id}`, data)
    return response.data.data
  },

  // Delete a tag
  async delete(id: string): Promise<void> {
    await api.delete(`/api/crm/tags/${id}`)
  },

  // ==================== Conversation Tags ====================

  // Get all tags for a conversation
  async getConversationTags(conversationId: string): Promise<Tag[]> {
    const response = await api.get(`/conversations/${conversationId}/tags`)
    return response.data.data
  },

  // Assign tag to conversation
  async addTagToConversation(conversationId: string, tagId: string): Promise<Tag> {
    const response = await api.post(`/conversations/${conversationId}/tags`, { tagId })
    return response.data.data
  },

  // Remove tag from conversation
  async removeTagFromConversation(conversationId: string, tagId: string): Promise<void> {
    await api.delete(`/conversations/${conversationId}/tags/${tagId}`)
  },

  // ==================== Contact Tags ====================

  // Get all tags for a contact
  async getContactTags(contactId: string): Promise<Tag[]> {
    const response = await api.get(`/api/crm/contacts/${contactId}/tags`)
    return response.data.data
  },

  // Assign tag to contact
  async addTagToContact(contactId: string, tagId: string): Promise<Tag> {
    const response = await api.post(`/api/crm/contacts/${contactId}/tags`, { tagId })
    return response.data.data
  },

  // Remove tag from contact
  async removeTagFromContact(contactId: string, tagId: string): Promise<void> {
    await api.delete(`/api/crm/contacts/${contactId}/tags/${tagId}`)
  },
}
